<template>
  <div class="results-item-video" :id="itemId">
    <div v-if="checked" class="item__badge d-flex">
      <div class="badge__text">
        {{ $t('resultsItem/inCart') }}
      </div>
    </div>
    <div class="item__image" :class="checked ? 'item__image--pressed' : ''" @click.stop="onImageClick">
      <div class="image__container">
        <div class="image__sizer"
          :style="{'padding-bottom': '56%'}"
        >
        </div>
        <div
          :style="{'background-image': 'url(' + (gifUrl || thumbnailUrl) + ')'}"
          class="image__image"
        ></div>
        <div class="image__frame" :style="{ 'background-image': `url('/img/video-frame-light.svg')` }"></div>
      </div>
    </div>
    <div class="item__text">
      <Icon name="video" size="m" /><span>{{ getVideoTypeName() }}</span>
    </div>
  </div>
</template>


<script lang="js">
import { mapGetters } from 'vuex';
import { ProductTypes } from '@/product-types';

export default {
  name: 'ResultsItemVideo',
  props: {
    videoId: String,
    thumbnailUrl: String,
    gifUrl: String,
    videoUrl: String,
    checked: Boolean,
    adding: Boolean,
    amount: Number,
    type: String,
    itemHovered: Boolean,
  },
  components: {},
  data() {
    return {
      itemId: '',
      hover: false,
      overMenu: false,
    };
  },
  computed: {
    ...mapGetters('SettingsState', ['theme']),
  },
  watch: {
    '$props.itemHovered'() {
      if (this.$props.itemHovered) {
        this.hover = true;  
      } else {
        this.hover = false;
      }
    },
  },
  methods: {
    getVideoTypeName() {
      if (this.$props.type === ProductTypes.fullVideo) return this.$t('searchFormVideo/fullVideo').toString();
      if (this.$props.type === ProductTypes.finishVideo) return this.$t('searchFormVideo/finishVideo').toString();
      return ''
    },
    onImageClick() {
      this.$emit('imageclick');
    },
    onAddToCart() {
      this.$emit('addtocart');
    },
  },
  mounted() {
    this.itemId = "results-item-" + this.$props.videoId;
  },
}
</script>


<style lang="scss" scoped>
  @import "./results-item-video";
</style>
